<template>
  <div class="Login">
        <div class="title">
            <strong>{{titleName}}</strong>
            <span class="exit" v-on:click="close()">X</span>
        </div>
        <div class="DataInfo">
            <div class="gray_border round_s scollbarY">
                <!--<h4 class="th_line_w btn_t"><span class="o_arrow m_1"></span><a>New PlaceMark Information</a></h4>-->
                <ul class="r_list">
                    <input class="fill_text box_size round_s" type="text" placeholder="User Name" v-model="userName">
                </ul>
                <ul class="r_list">
                    <input class="fill_text box_size round_s" type="text" placeholder="User PassWord" v-model="userPassword">
                </ul>
            </div>
            <div class="r_d_btn btn_layer cf2"> 
                <span class="l w_5">
                    <input type="button" class="round_s fill_btn_r blue_btn_b" value="LOGIN" v-on:click="login">
                </span> 
                <span class="r w_5">
                    <input type="button" class="round_s fill_btn_r gray_btn_g" value="CANCEL" v-on:click="close">
                </span> 
            </div>
        </div>
  </div>
</template>

<script>
  /* eslint-disable */
  export default {
    name: 'DrawToolBar',
    props: {
        userData: {
            default: '' 
        }
    },
    data () {
      return {
        msg: 'This is Loign!',
        titleName: 'User Login',
        userName: "",
        userPassword: ""
      }
    },
    mounted: function() {
    },
    methods: {
        login: function(){
            /*this.$axios.post(
              "http://172.18.0.169/PFNeoWebViewer_BackEnd/public/login",{
                  email: this.userName,
                  password: this.userPassword
            }).then(this.updateUserInfo,this.errorHandle);*/
            $.post({
                url: pfAirViewer._dataSave._baseUri+'/login',
                data: {
                    email: this.userName,
                    password: this.userPassword
                },
                success: this.updateUserInfo,
                dataType: "json"
            });
        },
        updateUserInfo: function(userInfo){
            this.userData.userInfo = userInfo;
            this.close();
        },
        errorHandle: function(info){
            console.log(info);
        },
        close: function() {
            this.$emit('close','');
        },
    },
    components: {
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
* {
    margin: 0;
    padding: 0;
    overflow:inherit;
}
.Login {
    position: fixed;
    z-index: 10000;
    border-radius: 5px;
    height: 30%;
    left: 40%;
    top: 25%;
    width: 20%;
    background: #f3f3f3 none repeat scroll 0 0;
    box-shadow: 10px 10px 30px #888888 ;
    border: medium none;
    padding: 0;
}
.title {
    background-color: #12285f;
    border: medium none;
    border-radius: 3px 3px 0 0;
    clear: both;
    color: #fff;
    height: 44px;
    line-height: 44px;
    overflow: hidden;
}
.title strong {
    display: block;
    font-size: 16px;
    font-weight: normal;
    text-align: center;
    text-transform: uppercase;
}
.title .exit {
    background: rgba(0, 0, 0, 0) url('../../static/Cesium/Assets/AirEarth/images/close_w.png') no-repeat scroll center center;
    border: medium none;
    cursor: pointer;
    display: block;
    height: 40px;
    line-height: 40px;
    position: absolute;
    right: 0;
    text-align: center;
    text-indent: -99999px;
    top: 0;
    width: 40px;
}
.DataInfo {
    padding: 1em 1em 1em;
    height: 100%;
}
.gray_border {
    background: #fff none repeat scroll 0 0;
    border: 1px solid #cecece;
    margin-bottom: 1em;
    height: 58%;
}
.th_line_w {
    border-bottom: 1px solid #cecece;
    font-size: 14px;
    font-weight: normal;
    height: 44px;
    line-height: 22px;
    padding: 9px 0;
}
.o_arrow {
  background-image: url("../../static/images/icon/arrow.png");
  background-repeat: no-repeat;
  float: left;
  height: 22px;
  margin-right: 0.2em;
  margin-left: 30px;
  overflow: hidden;
  width: 22px;
}
.box_size {
    box-sizing: border-box;
}
.progress {
  border-radius: 1px;
  display: none;
  height: 10%;
  padding: 0;
  position: absolute;
  width: 75%;
}
.percent {
  color: #fff;
  display: inline-block;
  height: 10px;
  left: 2%;
  position: relative;
  top: 3px;
}
textarea {
  resize: none;
}
.gray_border ul .t {
  margin-top: 0.8em;
}
.fill_text, .fill_textarea {
  background-color: #f3f3f3;
  border: 1px solid #e0e0e0;
  height: 38px;
  line-height: 32px;
  padding: 5px 5%;
  width: 100%;
}
.fill_text:focus, .fill_textarea:focus {
  background-color: #fff;
  border-color: #09aaf3;
  box-shadow: 0 0 3px rgba(0, 0, 0, 0.2);
}
.fill_textarea {
  height: 120px;
  overflow: visible;
}
.r_list {
  font-size: 14px;
  margin: 0.5em 1em;
}
ul {
  list-style: outside none none;
}
input {
    color: black;
}
a {
    text-decoration: none;
}
.select {
  background-color: #f3f3f3;
  background-image: url("../../static/images/icon/option.png");
  background-position: 95% center;
  background-repeat: no-repeat;
  border: 1px solid #e0e0e0;
  height: 32px;
  position: relative;
  text-align: left;
  width: 100%;
}
.select_box {
  background-color: #fff;
  border: 1px solid #e0e0e0;
  font-size: 14px;
  height: 42px;
  line-height: 42px;
  color: black;
}
.select ul {
  background-color: #fff;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);
  height: 0;
  left: 0;
  overflow: hidden;
  position: absolute;
  top: 20px;
  transition: height 0.3s ease-out 0s, top 0.3s ease-out 0s;
  width: 100%;
  z-index: 1;
}
.select.open ul {
  height: 150px;
  overflow-y: auto;
  top: -80px;
  transition: all 0.2s ease-in 0s;
}
.select.open ul li:nth-child(1) {
  transition: opacity 0.3s ease-in 0.05s, transform 0.3s ease-in 0.05s;
}
.select.open ul li {
  opacity: 1;
  transform: translateX(0px);
}
.select ul li {
  cursor: pointer;
  line-height: 30px;
  opacity: 0;
  padding: 0 15px;
  transform: translateX(300px);
  transition: transform 0.3s ease-out 0s;
}
.select ul li.selected {
  color: #0d5881;
}
.r_list li {
  margin: 0.6em 0;
}
.select_box p {
  height: 42px;
  line-height: 42px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  word-break: keep-all;
}
.select p {
  cursor: pointer;
  line-height: 32px;
  padding: 0.3em 1em;
}
.cf {
    overflow: hidden;
}
.cf2::after {
    clear: both;
    content: "";
    display: block;
    height: 0;
}
.l {
    float: left;
}
.r {
    float: right;
}
.w_5 {
    width: 48%;
}
.round_s, .round_s_img img {
    border-radius: 3px;
}
.blue_btn, .blue_btn_b:hover {
    background-color: #0d5881;
}
.blue_btn:hover, .blue_btn_b {
    background-color: #12285f;
}
.red_btn {
    background-color: #bf5442;
}
.red_btn:hover {
    background-color: #ac2b15;
}
.gray_btn, .gray_btn_g:hover {
    background-color: #c5c5c5;
}
.gray_btn:hover {
    background-color: #999;
}
.gray_btn_g {
    background-color: #e0e0e0;
    color: #555;
}
.fill_btn_r {
    border: medium none;
    color: #fff;
    cursor: pointer;
    font-size: 14px;
    line-height: 42px;
    text-align: center;
    vertical-align: top;
    width: 100%;
}
.btnupload {
    background-color: #0d5881;
    color: #fff;
    cursor: pointer;
    display: inline-block;
    font-size: 12px;
    margin-right: 4px;
    overflow: hidden;
    padding: 1px;
    height: 38px;
    text-align: center;
    vertical-align: middle;
}
.btnupload input {
    border: medium solid transparent;
    cursor: pointer;
    display: inline-block;
    margin: 0;
    opacity: 0;
    right: 0;
    top: -10px;
}
.fill_btn_load {
    border: medium none;
    color: #fff;
    cursor: pointer;
    font-size: 14px;
    line-height: 30px;
    vertical-align: top;
    width: 18%;
}
</style>


// WEBPACK FOOTER //
// src/components/Login.vue